import type {
  BobbinAgentSession,
  BobbinAttentionItem,
  BobbinContentItem,
  BobbinNode,
} from "./types";

export function bobbinNodeTitle(node: BobbinNode): string {
  const metadata = node.metadata ?? {};
  for (const value of [node.title, metadata.heading, metadata.title, metadata.name]) {
    if (typeof value === "string" && value.trim()) return redactBobbinSecrets(value.trim());
  }
  return node.concept_type || node.derived_kind || node.source_type || "Untitled node";
}

export function bobbinNodeKind(node: BobbinNode): string {
  return node.concept_type || node.derived_kind || node.source_type || "node";
}

export function bobbinContentText(item: BobbinContentItem): string {
  if (typeof item.text === "string" && item.text) return redactBobbinSecrets(item.text);
  if (typeof item.summary === "string" && item.summary) return redactBobbinSecrets(item.summary);
  return "Content is unavailable for this block.";
}

export function bobbinSessionLabel(session: BobbinAgentSession): string {
  if (typeof session.harness === "string" && session.harness.trim()) {
    return redactBobbinSecrets(session.harness.trim());
  }
  return "Agent session";
}

export function bobbinSessionContext(session: BobbinAgentSession): string {
  const context = session.project_context;
  if (context) {
    for (const value of [context.heading, context.title, context.name, context.path]) {
      if (typeof value === "string" && value.trim()) return redactBobbinSecrets(value.trim());
    }
  }
  if (typeof session.cwd === "string" && session.cwd.trim()) {
    return redactBobbinSecrets(session.cwd.trim());
  }
  return "No project context";
}

export function bobbinAttentionReason(item: BobbinAttentionItem): string {
  const reason = item.metadata?.reason;
  return typeof reason === "string" && reason.trim()
    ? redactBobbinSecrets(reason.trim())
    : "Needs attention";
}

export function formatBobbinTime(value?: string | null): string {
  if (!value) return "Time unavailable";
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return "Time unavailable";
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function localEntryDate(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function redactBobbinSecrets(value: string): string {
  return value.replace(/\bbmb_[A-Za-z0-9_-]+/g, "[redacted mobile credential]");
}
